import { TinyColor } from "@ctrl/tinycolor";
export const useAccessibleColors = () => {

    const complement = (color: string) => {
        return new TinyColor(color).complement().toRgbString();
    }
    const contrast = (color: string, amount: number) => {
        return (new TinyColor(color).isDark()) ? 
            new TinyColor(color).lighten(amount).toRgbString() : 
            new TinyColor(color).darken(amount).toRgbString();
    }
    const opacity = (color:string, opacity: number) => {
        return new TinyColor(color).setAlpha(opacity).toRgbString();
    }

    return {
        complement, contrast, opacity
    }
}

